import { DateOfBirthValues } from '@zuto/molecules'

const mapToDateOfBirth = (dateOfBirth?: DateOfBirthValues): string => {
  const day = dateOfBirth?.day
  const month = dateOfBirth?.month
  const year = dateOfBirth?.year
  if (!day || !month || !year) return ''

  return new Date(`${year}-${`0${month}`.slice(-2)}-${`0${day}`.slice(-2)}T00:00:00Z`).toISOString()
}

export default mapToDateOfBirth
